import $ from 'jquery';

const $ymap = $('#id_map');

if ($ymap.length) {
    window.ymaps.ready(() => {
        const myMap = new window.ymaps.Map('id_map', {
                center: [56.0, 94.0],
                zoom: 6,
                controls: ['zoomControl', 'geolocationControl'],
            }),

            $map = $('#id_map'),
            $notice = $('#id_map_notice'),
            $but = $('#id_map_search_but'),
            $str = $('#id_map_search_str'),
            $data_map = $('#id_data_map'),
            $show_map_link = $('.js-show-map'),
            $hide_map_link = $('.js-hide-map'),

            objectManager = new window.ymaps.ObjectManager({
                clusterize: true,
                gridSize: 32,
                clusterDisableClickZoom: false,
            }),

            loadBalloonData = objectId => {
                const dataDeferred = window.ymaps.vow.defer();
                $.ajax({
                    url: $map.data('detail-url'),
                    data: {id: objectId},
                }).done(
                    data => dataDeferred.resolve(data)
                );
                return dataDeferred.promise();
            },

            hasBalloonData = objectId => objectManager.objects.getById(objectId).properties.balloonContent,

            openBalloon = objectId => {
                const obj = objectManager.objects.getById(objectId);

                $notice.slideUp();

                if (hasBalloonData(objectId)) {
                    objectManager.objects.balloon.open(objectId);
                } else {
                    obj.properties.balloonContent = 'Идет загрузка данных...';
                    objectManager.objects.balloon.open(objectId);
                    loadBalloonData(objectId).then(data => {
                        obj.properties.balloonContentHeader = data.balloonContentHeader;
                        obj.properties.balloonContentBody = data.balloonContentBody;
                        obj.properties.balloonContentFooter = data.balloonContentFooter;
                        objectManager.objects.balloon.setData(obj);
                    });
                }
            },

            moveTo = (objectId) => {
                const obj = objectManager.objects.getById(objectId);

                myMap.panTo([obj.geometry.coordinates[0], obj.geometry.coordinates[1]], {
                    duration: 1000,
                }).then(() => {
                    myMap.setZoom(17, {
                        duration: 1000,
                    }).then(
                        () => openBalloon(objectId)
                    );
                });
            },

            showError = (message) => {
                $notice.text(message);
                $str.addClass('input_error');
                $notice.css('display', 'block');
            },

            showResult = geo_obj => {
                $.ajax({
                    url: $map.data('search-url'),
                    data: {lat: geo_obj.geometry.getCoordinates()[0], lon: geo_obj.geometry.getCoordinates()[1]},
                }).done(
                    data => {
                        if (data.house) {
                            moveTo(data.house);
                            $str.removeClass('input_error');
                        } else {
                            showError('Нет данных о ремонте в данном доме.');
                        }
                    }
                );
            },

            geocode = () => {
                const request = $('#id_map_search_str').val();

                // Геокодируем введённые данные.
                window.ymaps.geocode(request).then(function (res) {
                    const obj = res.geoObjects.get(0);
                    let error;

                    if (obj) {
                        // Об оценке точности ответа геокодера можно прочитать тут:
                        // https://tech.yandex.ru/maps/doc/geocoder/desc/reference/precision-docpage/
                        switch (obj.properties.get('metaDataProperty.GeocoderMetaData.precision')) {
                        case 'exact':
                            break;
                        case 'number':
                        case 'near':
                        case 'range':
                            error = 'Неточный адрес, требуется уточнение. Уточните номер дома.';
                            break;
                        case 'street':
                            error = 'Неполный адрес, требуется уточнение. Уточните номер дома.';
                            break;
                        case 'other':
                        default:
                            error = 'Неточный адрес, требуется уточнение. Уточните адрес.';
                        }
                    } else {
                        error = 'Адрес не найден. Уточните адрес.';
                    }

                    // Если геокодер возвращает пустой массив или неточный результат, то показываем ошибку.
                    if (error) {
                        showError(error);
                    } else {
                        showResult(obj);
                    }
                }, e => {
                    console.log(e);
                });
            },

            showMap = () => {
                $show_map_link.fadeOut();
                $map.slideDown(() => $hide_map_link.fadeIn());
            },

            hideMap = () => {
                $hide_map_link.fadeOut();
                $map.slideUp(() => $show_map_link.fadeIn());
            };


        if ($data_map.length && $data_map.data('hidden') === true) {
            $hide_map_link.hide();
            $map.hide(() => $show_map_link.show());
        }

        myMap.behaviors.disable('scrollZoom');
        new window.ymaps.SuggestView('id_map_search_str');

        objectManager.objects.events.add('click', e => openBalloon(e.get('objectId')));
        objectManager.objects.options.set('preset', 'islands#blueDotIcon');
        objectManager.clusters.options.set('preset', 'islands#blueClusterIcons');
        myMap.geoObjects.add(objectManager);

        $but.click(e => {
            e.preventDefault();
            if (!$map.is(':visible')) showMap(e);
            geocode();
        });
        $(document).keypress(e => {
            if (e.which === 13) {
                if (!$map.is(':visible')) showMap(e);
                geocode();
            }
        });

        $.ajax({
            url: $map.data('list-url'),
        }).done(
            data => {
                objectManager.add(data);
                const sel = $data_map.data('selected');
                if ($data_map.length && sel) {
                    moveTo(sel);
                }
            }
        );

        $show_map_link.click((e) => {
            e.preventDefault();
            showMap(e);
        });

        $hide_map_link.click((e) => {
            e.preventDefault();
            hideMap(e);
        });

    });
}



// WEBPACK FOOTER //
// ./js/home/map.js